'use client'
import React from 'react'
import Heading from './Heading'
import { useAds } from '@/hooks/useAds'
import { Advertisement } from '@/models/ads.model'
import Link from 'next/link'
import Image from 'next/image'
import { SwiperSlide, Swiper } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/effect-creative'
import { Autoplay } from 'swiper/modules'

const AdsArticles = () => {
  const { data } = useAds()
  console.log('data asd', data)
  return (
    <>
      <Heading>Quảng cáo</Heading>

      {/* Slider 1: 3 hình 300x300 giữ nguyên */}
      <Swiper
        className="mb-5"
        modules={[Autoplay]}
        spaceBetween={10}
        slidesPerView={1}
        loop
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={false}
        navigation={false}
      >
        <SwiperSlide>
          <article className="w-full h-auto relative">
            <Link href="/" target="_blank" rel="noopener noreferrer">
              <Image
                src="/Image/Halfpage_AD_300x600px_3.jpg"
                alt="Halfpage_AD_300x600px_3"
                width={300}
                height={300}
                className="object-cover"
                layout="responsive"
              />
            </Link>
          </article>
        </SwiperSlide>
        <SwiperSlide>
          <article className="w-full h-auto relative">
            <Link href="/" target="_blank" rel="noopener noreferrer">
              <Image
                src="/Image/Halfpage_AD_300x600px_4.jpg"
                alt="Halfpage_AD_300x600px_4"
                width={300}
                height={300}
                className="object-cover"
                layout="responsive"
              />
            </Link>
          </article>
        </SwiperSlide>
        <SwiperSlide>
          <article className="w-full h-auto relative">
            <Link href="/" target="_blank" rel="noopener noreferrer">
              <Image
                src="/Image/Halfpage_AD_300x600px_5.jpg"
                alt="Halfpage_AD_300x600px_5"
                width={300}
                height={300}
                className="object-cover"
                layout="responsive"
              />
            </Link>
          </article>
        </SwiperSlide>
      </Swiper>

      {/* Hai ảnh cao hiển thị tĩnh theo thứ tự: hình 2 -> hình 1 */}
      <div className="mb-5 space-y-5">
        <article className="w-full h-auto relative">
          <Link href="/" target="_blank" rel="noopener noreferrer">
            <Image
              src="/Image/Halfpage_AD_300x600px_1.jpg"
              alt="Halfpage_AD_300x600px_2"
              width={300}
              height={600}
              className="object-cover"
              layout="responsive"
            />
          </Link>
        </article>
        <article className="w-full h-auto relative">
          <Link href="/" target="_blank" rel="noopener noreferrer">
            <Image
              src="/Image/Halfpage_AD_300x600px_2.jpg"
              alt="Halfpage_AD_300x600px_1"
              width={300}
              height={600}
              className="object-cover"
              layout="responsive"
            />
          </Link>
        </article>
      </div>

      <ul>
        <li className="mt-6">
          <article className="w-full h-auto relative">
            <Link href="https://dalatnewfarm.com" target="_blank" rel="noopener noreferrer">
              <Image
                src="/Image/banner3.jpg"
                alt="Đông trùng hạ thảo"
                width={300}
                height={300}
                className="object-cover"
                layout="responsive"
              />
            </Link>
          </article>
        </li>
        {data?.map((ad: Advertisement) => {
          // Kiểm tra và lấy URL hợp lệ
          const url = ad.url ? ad.url.split('iamtapnews.com')[1] || ad.url : '#'
          return (
            <li key={ad.id} className="mb-6">
              <article className="w-full h-auto relative">
                <Link href={url} target="_blank" rel="noopener noreferrer">
                  <Image
                    src={
                      `${process.env.NEXT_PUBLIC_IMAGE_URL}${ad.imageUrl}` ||
                      '/placeholder-image.jpg'
                    }
                    alt={ad.name || 'Quảng cáo'}
                    width={300}
                    height={300}
                    className="object-cover"
                    layout="responsive"
                  />
                </Link>
              </article>
            </li>
          )
        })}
      </ul>
    </>
  )
}

export default AdsArticles
